import { Component, OnInit, Input, Output, EventEmitter, AfterContentInit, SimpleChanges, OnChanges, ViewChild, OnDestroy } from '@angular/core';
import { GridService } from 'app/Shared/Services/grid.service';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { UserService } from 'app/Shared/Services/user.service';
import { Subscription } from 'rxjs';
import { CommonModule, DecimalPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';

@Component({
    selector: 'app-symbol-panel',
    imports: [CommonModule, ButtonModule, MatTooltipModule, TableModule, MatExpansionModule,
        MatChipsModule, MatProgressSpinnerModule, MatChipsModule, MatExpansionModule,
        ConfirmDialogModule, FormsModule, DecimalPipe
    ],
    templateUrl: './symbol-panel.component.html',
    styleUrls: ['./symbol-panel.component.scss']
})
export class SymbolPanelComponent implements OnInit, OnChanges,AfterContentInit, OnDestroy {
  @Input('SymbolArray') SymbolArray: any[] = [];
  @Input('CodeArray') CodeArray: any[] = [];
  @Input('CodeBlockArray') CodeBlockArray: any[] = [];
  @Input('GroupNameArray') GroupNameArray: any[] = [];
  @Input('SampleNameArray') SampleNameArray: any[] = [];
  @Input('ActiveExceptionCode') ActiveExceptionCode: any = '';
  @Input('quickFilterEventTypeArray') quickFilterEventTypeArray: any[] = [];
  @Input('applicationFiltersArray') applicationFiltersArray: any[] = [];
  @Input('isDisplayCodeBlock') isDisplayCodeBlock: boolean = false;
  @Input('Reset') Reset!: boolean;
  @Input('rowCount') rowCount: any;
  @Input('rowCountCode') rowCountCode: any;
  @Input('rowCountSymbol') rowCountSymbol: any;
  @Input('rowCountSymbolEventType') rowCountSymbolEventType: any;
  @Input('selectedApplicationFilter') selectedApplicationFilter: any;
  @Input('ResetLabel') ResetLabel: any;
  @Output() ActiveSymbolEvent: EventEmitter<any> = new EventEmitter();
  @Output() ActiveCodeEvent: EventEmitter<any> = new EventEmitter();
  @Output() ActiveQuickFilterEventType:  EventEmitter<any> = new EventEmitter();
  @Output() ActiveQuickFilterGroupName:  EventEmitter<any> = new EventEmitter();
  @Output() ActiveQuickFilterSampleName:  EventEmitter<any> = new EventEmitter();
  @Output() ActiveApplicationFilter:  EventEmitter<any> = new EventEmitter();
  @Output() RemoveApplicationFilterQuery:  EventEmitter<any> = new EventEmitter();
  @Output() RemoveCustomSampleFilterQuery:  EventEmitter<any> = new EventEmitter();
  
  activeSymbol: any = '';
  activeCode: string = '';
  activeSymbolEventType: string = '';
  activeGroupName = "";
  activeSampleName:any= "";
  Symbol: any = [];
  Code: any = [];
  quickFilterEventType: any = [];
  recordCount:any;
  NewCodeArray: any = [];
  CodeBlockArrayList: any = [];
  ApplicationFilterArray: any = [];
  DateList: Array<any> = ['2020-2-18', '2020-1-16','2020-3-23'];
  visible = true;
  selectable = true;
  removable = false;
  addOnBlur = true;
  activeDate: string = '';
  isDateFilterApplied!: boolean
  subscription: Subscription;
  constructor(private gridService: GridService,
    private emitterService: EmitterService,
    private userService: UserService) {
    this.subscription = this.emitterService.ResetQuickFilterPanelEvent.subscribe(event => {
      if (event == "All") {
        this.rowCountSymbol = '';
        this.recordCount="";
        this.activeSymbol = "";
        this.activeCode = "";
        this.activeSymbolEventType = "";
        this.activeGroupName = "";
      }
      if(event == "QuickFilterEventType") {
        this.rowCountSymbolEventType = '';
        this.recordCount="";
        this.activeSymbolEventType = "";
      } 
      if (event == "Symbol") {
        this.rowCountSymbol = '';
        this.recordCount="";
        this.activeSymbol = "";
      }
      if (event == "Code") {
        this.rowCountCode = '';
        this.recordCount="";
        this.activeCode = "";
      }
      if (event == "GroupName") {
        this.rowCountCode = '';
        this.recordCount="";
        this.activeGroupName = "";
      }

      if (event == "SampleName") {
        this.rowCountCode = '';
        this.recordCount="";
        this.activeSampleName = "";
      }

    });
  }
  ngOnInit() {
    this.rowCountSymbol = ''
    this.activeSymbol = "";
    this.activeCode = this.ActiveExceptionCode;
    this.activeSymbolEventType = "";
    this.recordCount="";
    this.activeGroupName = "";
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.ApplicationFilterArray = this.applicationFiltersArray; // Get All Application Filters
    if (this.SymbolArray)
    this.Symbol = this.SymbolArray.sort((a, b) => a.localeCompare(b));

    if (this.CodeArray) {
      this.NewCodeArray = [];
      for (let i = 0; i < this.CodeArray.length; i++) {
        let CodeValue:any [] = this.CodeArray[i].split('-');
        this.NewCodeArray[i] = { code: CodeValue[0], description: CodeValue[1], count: CodeValue[2] }
      }
    }

    // Re-initialize CodeBlock List
    this.CodeBlockArrayList = (this.CodeBlockArray && this.CodeBlockArray.length > 0) ? this.CodeBlockArray : [];

  }

  ngAfterContentInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.

  }

  getName(type: string, value: string, index:any):void {
    /* Catch User Action Log */
      let filerType = type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
      this.userService.logUserActivity("User Applied " + filerType + " from Filter List", null, {
        'Text1': this.userService.userFirstName + ' applied ' + filerType + ' from Filter List',
        'Text2': 'User searched for - ' + filerType + ': ' + value
      });

    if (type.toUpperCase() === 'QUICKFILTEREVENTTYPE') {
      this.activeSymbolEventType = value;
      this.recordCount = '';
      this.rowCount='';
      this.rowCountSymbolEventType = '';
      this.ActiveQuickFilterEventType.emit(value);
    }
    if (type.toUpperCase() === 'SYMBOL') {
      this.activeSymbol = value;
      this.recordCount = '';
      this.rowCount='';
      this.rowCountSymbol = '';
      this.ActiveSymbolEvent.emit(value);
    }
    if (type.toUpperCase() === 'CODE') {
      this.activeCode = value;
      this.recordCount = '';
      this.rowCount='';
      this.rowCountCode = '';
      this.ActiveCodeEvent.emit(value);
    }

    if (type.toUpperCase() === 'GROUPNAME') {
      this.activeGroupName = value;
      this.ActiveQuickFilterGroupName.emit(value);
    }

    if (type.toUpperCase() === 'SAMPLENAME') {
      this.activeSampleName = value;
    }

    if (type.toUpperCase() === 'DATE') {
      this.activeDate = value;
    }
  }

  getSelectedApplicationFilter(optedApplicationFilter:any) {
    /* Catch User Action Log */
      this.userService.logUserActivity("Applied Application Filter", null, {
        'Text1': this.userService.userFirstName + ' Applied Application Filter',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(optedApplicationFilter)
      });
    this.ActiveApplicationFilter.emit(optedApplicationFilter);
  }

  removeApplicationFilterQuery(optedApplicationFilter:any) {
    /* Catch User Action Log */
      this.userService.logUserActivity("Removed Application Filter: "+optedApplicationFilter.filter_query_name, null, {
        'Text1': this.userService.userFirstName + ' Removed Application Filter',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(optedApplicationFilter)
      });
    this.RemoveApplicationFilterQuery.emit(optedApplicationFilter);
  }
  
 removeCustomSampleFilterQuery(optedApplicationFilter:any) {
    /* Catch User Action Log */
      this.userService.logUserActivity("Removed Custom Sample Filter: "+optedApplicationFilter.filter_query_name, null, {
        'Text1': this.userService.userFirstName + ' Removed Custom Sample Filter: '+optedApplicationFilter.filter_query_name,
        'Text2': 'User Filter Parameters: ' + JSON.stringify(optedApplicationFilter)
      });
    this.RemoveCustomSampleFilterQuery.emit(optedApplicationFilter);
  }

  setCustomSampleFilter(customSample:any){
    /* Catch User Action Log */
      this.userService.logUserActivity("Applied Custom Sample Filter: "+customSample.filter_query_name, null, {
        'Text1': this.userService.userFirstName + ' Applied Custom Sample Filter:'+customSample.filter_query_name,
        'Text2': 'User Filter Parameters: ' + JSON.stringify(customSample)
      });
    this.emitterService.ActiveCustomSampleFilterQuery.emit(customSample);
  }

  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }

  
}